import template from './order-history-list.html';
export var OrderHistoryListComponent = {
    template: template,
    controller: /** @class */ (function () {
        /*@ngInject*/
        function OrderHistoryController(Auth, $state, $scope, OrderService, googleAnalytic, $filter, $log, $timeout, $window, $cacheFactory, seoMetaService) {
            this.scrollPageCacheTag = 'order-history';
            this.scrollPositionCacheKey = 'order-history-scroll-position';
            this.pageSettingsCacheKey = 'order-history-search-settings';
            this.searchOrderDate = ''; // set the default search/filter term
            this.busyLoad = false;
            this.sortType = 'createDate'; // set the default sort type
            this.sortReverse = false; // set the default sort order
            this.searchTerm = ""; // set the default search term
            this.sortDays = 0; // set the default sort days
            this.errors = {};
            this.showAlert = false;
            this.closeAlertMessage = function () {
                this.showAlert = false;
            };
            this.trackingIndex = null;
            this.setTrackingItem = function (itemId) {
                if (itemId == this.trackingIndex) {
                    this.trackingIndex = null;
                }
                else {
                    this.trackingIndex = itemId;
                    this.mobileMenuToggle = null;
                }
            };
            this.$scope = $scope;
            var self = this;
            self.$log = $log;
            self.orderService = OrderService;
            this.seoMetaService = seoMetaService;
            this.seoMetaService.updateSeoMetaData(this, 'OrderHistoryController');
            self.ga = googleAnalytic;
            self.$timeout = $timeout;
            self.$window = $window;
            this.cache = $cacheFactory.get(this.scrollPageCacheTag) || $cacheFactory(this.scrollPageCacheTag);
            this.orderPageModel = {
                currentPage: 1,
                pageSize: 10,
                totalPages: 1,
                pages: [1]
            };
            this.initPageSettingsFromCache();
        }
        OrderHistoryController.prototype.filterByLastNDays = function (sortDays) {
            var _this = this;
            this.searchTerm = "";
            this.orderService.getOrders(1, this.orderPageModel.pageSize, this.sortType, this.sortReverse, sortDays)
                .then(function (response) {
                if (response) {
                    _this.orders = response.currentPage;
                    _this.updateOrderPageModel(response);
                }
                else {
                    _this.orders = [];
                    _this.updateOrderPageModel({ totalResults: 0 });
                }
            });
        };
        OrderHistoryController.prototype.initPageSettingsFromCache = function () {
            var pageSettings = this.cache.get(this.pageSettingsCacheKey);
            if (pageSettings) {
                if (pageSettings.currentPage) {
                    this.orderPageModel.currentPage = pageSettings.currentPage;
                }
                if (pageSettings.pageSize) {
                    this.orderPageModel.pageSize = pageSettings.pageSize;
                }
                if (pageSettings.sortType) {
                    this.sortType = pageSettings.sortType;
                }
                if (pageSettings.sortReverse) {
                    this.sortReverse = pageSettings.sortReverse;
                }
                if (pageSettings.searchTerm) {
                    this.searchTerm = pageSettings.searchTerm;
                }
                if (pageSettings.sortDays) {
                    this.sortDays = pageSettings.sortDays;
                }
            }
        };
        OrderHistoryController.prototype.cacheScrollPosition = function () {
            var scrollPosition = {
                x: this.$window.pageXOffset,
                y: this.$window.pageYOffset
            };
            var pageSettings = {
                currentPage: this.orderPageModel.currentPage,
                pageSize: this.orderPageModel.pageSize,
                sortType: this.sortType,
                sortReverse: this.sortReverse,
                searchTerm: this.searchTerm,
                sortDays: this.sortDays
            };
            this.cache.put(this.pageSettingsCacheKey, pageSettings);
            this.cache.put(this.scrollPositionCacheKey, scrollPosition);
        };
        OrderHistoryController.prototype.goToCacheScrollPosition = function (self) {
            var scrollPosition = self.cache.get(self.scrollPositionCacheKey);
            if (scrollPosition) {
                self.$window.scrollTo(scrollPosition.x, scrollPosition.y);
            }
        };
        OrderHistoryController.prototype.orderPageChanged = function () {
            var _this = this;
            this.orderService.getOrders(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.sortDays, this.searchTerm)
                .then(function (response) {
                _this.orders = response.currentPage;
                _this.updateOrderPageModel(response);
            });
        };
        OrderHistoryController.prototype.updateOrderPageModel = function (response) {
            this.orderPageModel.totalPages = Math.ceil(response.totalResults / this.orderPageModel.pageSize);
            this.orderPageModel.pages = Array.from({ length: this.orderPageModel.totalPages }, function (x, i) { return i + 1; });
            this.orderPageModel.currentPage = response.pageNumber;
            this.$timeout(this.goToCacheScrollPosition, 500, false, this);
        };
        OrderHistoryController.prototype.searchOrder = function () {
            var _this = this;
            this.orderPageModel.currentPage = 1;
            this.sortType = 'createDate';
            this.sortReverse = false;
            this.sortDays = 0;
            this.orderService.getOrders(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.sortDays, this.searchTerm)
                .then(function (response) {
                if (response) {
                    _this.orders = response.currentPage;
                    _this.updateOrderPageModel(response);
                }
                else {
                    _this.orders = [];
                    _this.updateOrderPageModel({ totalResults: 0 });
                }
            });
        };
        OrderHistoryController.prototype.queryOrder = function () {
            var _this = this;
            this.orderPageModel.currentPage = 1;
            this.orderService.getOrders(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.sortDays, this.searchTerm)
                .then(function (response) {
                if (response) {
                    _this.orders = response.currentPage;
                    _this.updateOrderPageModel(response);
                }
                else {
                    _this.orders = [];
                    _this.updateOrderPageModel({ totalResults: 0 });
                }
            });
        };
        OrderHistoryController.prototype.trackEvent = function (eventName) {
            this.ga.sendEvent('Customer', 'Order History Page', eventName, 1);
        };
        OrderHistoryController.prototype.handleApiError = function (response) {
            var self = this;
            self.errors.havePageErrors = true;
            self.errors.pageErrorType = 'api';
            self.showAlert = true;
            if (response.data && response.data.errors && response.data.errors.length > 0) {
                self.errors.pageErrors = response.data.errors;
            }
            else {
                self.errors.pageErrors = [{ code: response.status, message: response.statusText + ' | ' + response.data }];
            }
        };
        OrderHistoryController.prototype.$onInit = function () {
            var self = this;
            this.orderService.getOrders(this.orderPageModel.currentPage, this.orderPageModel.pageSize, this.sortType, this.sortReverse, this.sortDays, this.searchTerm)
                .then(function (response) {
                self.orders = response.currentPage;
                self.updateOrderPageModel(response);
                self.originalOrders = self.orders;
            }, function (response) {
                self.$log.error('response is...', response);
                self.handleApiError(response);
            });
        };
        return OrderHistoryController;
    }())
};
//# sourceMappingURL=order-history-list.component.js.map